import React from 'react';
import { ChevronDown, ChevronUp } from '../../../bravosIcons';
import type { LibraryWorkoutsApi } from '../../hooks/useLibraryWorkouts';
import type { WorkoutSortColumn } from '../../types/library';

export function hasWorkoutFilter(wk: LibraryWorkoutsApi, column: WorkoutSortColumn): boolean {
  switch (column) {
    case 'name':
      return wk.workoutNameFilter.trim() !== '';
    case 'createdAt':
      return wk.workoutDateFilter !== '';
    case 'exercises':
      return false;
    default:
      return false;
  }
}

export function clearWorkoutFilter(wk: LibraryWorkoutsApi, column: WorkoutSortColumn): void {
  switch (column) {
    case 'name':
      wk.setWorkoutNameFilter('');
      break;
    case 'createdAt':
      wk.setWorkoutDateFilter('');
      wk.setWorkoutDateFilterType('exact');
      wk.setWorkoutDateFilterEnd('');
      break;
  }
}

export function WorkoutSortIcon({ wk, column }: { wk: LibraryWorkoutsApi; column: WorkoutSortColumn }) {
  if (wk.workoutSortColumn !== column) {
    return <ChevronUp className="w-4 h-4 text-theme-text/50 dark:text-theme-off-white/50 opacity-0 group-hover:opacity-50" />;
  }
  return wk.workoutSortDirection === 'asc'
    ? <ChevronUp className="w-4 h-4 text-theme-text dark:text-theme-off-white" />
    : <ChevronDown className="w-4 h-4 text-theme-text dark:text-theme-off-white" />;
}
